var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPageWithCreateButton',{attrs:{"createRoute":{
    name: 'create-canteen-category',
    params: {id: this.$route.params.id}
  },"showCreateBtn":_vm.checkUserRole('SND'),"createBtnName":_vm.$t('canteen.createCategory')}},[_c('template',{slot:"listDataContent"},[_c('CanteenUserTable',{attrs:{"headers_prop":_vm.headers,"list_url_prop":`canteen/${_vm.$route.params.id}/category`,"loading":_vm.loading}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }